import { createJiraTicket } from '../../services/ContactService';
import { errorToastr, successToastr } from '../../Utils/ToastrMessage';


export const GET_DASHBOARD_FAILED_ACTION = '[getDashboard action] failed getDashboard';

export const CREATE_JIRA_TICKET_CONFIRMED_ACTION = '[createJiraTicket action] confirmed createJiraTicket';

export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';

var I18n = require('react-redux-i18n').I18n;



export function createJiraTicketAction(data) {
    return (dispatch) => {
        createJiraTicket(data)
        .then((response) => {
            let data = response.data;
            successToastr('Ticket Jira créé avec succès, trouvez le lien ci-dessous');
            dispatch(confirmedCreateJiraTicketAction(data));
        })
        .catch((error) => {
            console.log(error);
            errorToastr('Erreur lors de la création'+error.response?.data?.message);
            dispatch(getDashboardDataFailedAction(error.response?.data?.message));
        });
    };
}

export function confirmedCreateJiraTicketAction(data) {
    return {
        type: CREATE_JIRA_TICKET_CONFIRMED_ACTION,
        payload: data,
    };
}

export function getDashboardDataFailedAction(data) {
    return {
        type: GET_DASHBOARD_FAILED_ACTION,
        payload: data,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}